export default "__VITE_ASSET__54cb38d4__"